import { Injectable } from '@angular/core';
import { createClient, Entry, Asset, EntryCollection } from 'contentful';

const CONFIG = {
  space: 'lm3zkd6fnywn',
  accessToken: '89b1f7ea11e0aa726e1aa50de0072a412e6f1771023c8af99bc5b85b4de43b0d',

  contentTypeIds: {
    program: 'programOpen',
    module: 'moduleProgramOpen',
    activity: 'activityModuleOpen',
    topic: 'topicModuleOpen',
    resource: 'resourceTopicOpen'
  }
}

@Injectable({
  providedIn: 'root'
})
export class ContentfulService {

  private cdaClient = createClient({
    space: CONFIG.space,
    accessToken: CONFIG.accessToken
  });

  constructor() { }

  getPrograms(query?: object): Promise<Entry<any>[]> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: CONFIG.contentTypeIds.program
    }, { 'order': "fields.order" }))
      .then(res => res.items);
  }

  getProgram(Id): Promise<Entry<any>> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: CONFIG.contentTypeIds.program
    }, { 'sys.id': Id }))
      .then(res => res.items[0]);
  }

  getProgramAsset(Order): Promise<EntryCollection<any>> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: CONFIG.contentTypeIds.program
    }, { 'fields.order': Order }))
      .then(res => res);
  }

  getModule(Id): Promise<Entry<any>> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: CONFIG.contentTypeIds.module
    }, { 'sys.id': Id }))
      .then(res => res.items[0]);
  }

  getModulesByProgram(ProgramId): Promise<Entry<any>[]> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: CONFIG.contentTypeIds.module
    }, { 'fields.programOpen.sys.id': ProgramId, 'order': "fields.order" }))
      .then(res => res.items);
  }

  getModulesAssetsByProgram(ProgramId): Promise<EntryCollection<any>> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: CONFIG.contentTypeIds.module
    }, { 'fields.programOpen.sys.id': ProgramId, 'order': "fields.order" }))
      .then(res => res);
  }

  getTopicsByModule(ModuleId): Promise<Entry<any>[]> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: CONFIG.contentTypeIds.topic
    }, { 'fields.module.sys.id': ModuleId, 'order': "fields.order" }))
      .then(res => res.items);
  }

  getActivitiesByModule(ModuleId): Promise<Entry<any>[]> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: CONFIG.contentTypeIds.activity
    }, { 'fields.moduleOpen.sys.id': ModuleId }))
      .then(res => res.items);
  }

  getActivitiesAssetsByModule(ModuleId): Promise<EntryCollection<any>> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: CONFIG.contentTypeIds.activity
    }, { 'fields.moduleOpen.sys.id': ModuleId }))
      .then(res => res);
  }

  getResourcesByTopic(TopicId): Promise<Entry<any>[]> {
    return this.cdaClient.getEntries(Object.assign({
      content_type: CONFIG.contentTypeIds.resource
    }, { 'fields.topic.sys.id': TopicId, 'order': "fields.order" }))
      .then(res => res.items);
  }
}
